import { getStatusTextClass } from '../../../../services/oathAgencyVitalsService';

// Summary stat for welcome header - compact with status color support
const SummaryStat = ({ label, value, status = 'normal' }) => {
  const textClass = getStatusTextClass(status);

  return (
    <div className="text-center px-3 qhd:px-4 4k:px-5">
      <p className={`text-lg qhd:text-xl 4k:text-2xl font-bold ${textClass}`}>{value}</p>
      <p className="text-[10px] qhd:text-xs 4k:text-sm text-gray-500 dark:text-gray-400 uppercase tracking-wide">{label}</p>
    </div>
  );
};

export default SummaryStat;
